import React, { useState, useEffect, useRef } from 'react';
import AlertDialog from '../../../UI/AlertDialog';
import { Accordion, Grid, Typography, AccordionSummary, AccordionDetails, CircularProgress, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Storage } from 'aws-amplify';
import PdfComponent from '../../../Viewer/PdfViewer/PdfComponent';
import Sticky from 'react-sticky-el';
import VerticalLinearStepper from './verticalStepper';
import useMutationObserver from '@rooks/use-mutation-observer';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import { DropContainer } from './Drop-Container.js';
import { DropSignatures } from './Drop-Signatures.js';
import FinalEmailModal from './FinalEmailModal/FinalEmailModal';
import GraphqlApi from '../../../../api-graphql';

const useStyles = makeStyles(() => ({
  root: {
    background: 'transparent',
    borderBottom: '1px solid #D1D1D1',
    boxShadow: 'none',
    '&::before': {
      backgroundColor: 'transparent'
    },
    '& > .Mui-expanded': {
      borderTop: '0px',
      borderRight: '0px',
      borderLeft: '0px',
      border: '10px solid white'
    }
  },
  expanded: {
    backgroundColor: '#E5E5E5'
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  containerPdf: {
    width: '100%',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden'
  }
}));

const CustomFlow = ({ onSubmit, formRef, steps, document: documentItem, setSelected }) => {
  if (!documentItem.annexes) documentItem.annexes = [];
  const { t } = useTranslation();
  const page = document.getElementsByClassName('page');
  let pageHeight;
  const paddingAccordion = 30;
  const pageBottomMargin = 10;
  if (page.length) pageHeight = page[0].clientHeight;
  const myRef = useRef();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(true);
  const [finalEmailModal, setFinalEmailModal] = useState(false);
  const [annexesUrl, setAnnexesUrl] = useState([]);
  const [expanded, setExpanded] = useState(0);
  const [ filesName, setFileName ] = useState([]);
  const [loadingSignatures, setLoadingSignatures] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [notValidatedEmails, setNotValidatedEmails] = useState(false);
  const [numberOfPages, setNumberOfPages] = useState([]);

  // This state is olny used to force render when a changes on the stepsSignatures is made
  const [stepsCopyRender, setStepsCopyRender] = useState([]);
  // This is de main state of the CustomFlow
  const [stepsSignatures, setStepsSignatures] = useState([]);
  const [, setWriting] = useState(false);
  const initilizeStepsSignatures = () => {
    const initialStepsSignatures = [];
    for (let i = 0; i < documentItem.annexes.length + 1; i++) {
      initialStepsSignatures.push([{
        signaturePositionId: 'qrDefault',
        step: {
          id: 10,
          type: 'qrSignStep',
          visible: false,
          attach: true,
          automatic: true
        },
        isValidated: true,
        position: {
          x: width - 120,
          y: pageHeight ? pageHeight - 120 : 0
        },
        size: {
          width: 100,
          height: 100
        },
        positioned: true
      }]);
    }
    setStepsSignatures(initialStepsSignatures);
  };

  useEffect(() => {
    if (!loading) {
      initilizeStepsSignatures();
    }
  }, [loading]);

  useEffect(() => {
    documentItem.principal.signaturesPositions = [];
    documentItem.annexes.forEach((annex) => {
      annex.signaturesPositions = [];
    });
  }, []);
  useEffect(() => {
  }, [annexesUrl]);

  useEffect(() => {
    if (width && height) {
      setLoading(false);
    }
  }, [width, height]);
  const [leftMargin, setLeftMargin] = useState(0);

  let { annexes, name, principal, type } = documentItem;
  let input = documentItem;
  const downloadFileFromS3 = async () => {
    let listNamesFilesS3 = [];
    let listFilesUrlS3 = [];
    let urls = [];
    const url = await Storage.get(documentItem.fileUrl.replace(/[.]\w{3,4}$/, '.pdf'));
    listNamesFilesS3.push(principal ? principal.name : name);
    if (annexes.length > 0) {
      let arrayPromise = annexes.map((file) => {
        let urlPdf = file.path.replace(/[.]\w{3,4}$/, '.pdf');
        listNamesFilesS3.push(file.name);
        return Storage.get(urlPdf);
      });
      listFilesUrlS3 = await Promise.all(arrayPromise);
      urls = listFilesUrlS3.map((file, i) => ({ url: file, original: annexes[i].path }));
      urls.unshift({ url: url, original: url });
    }
    if (annexes.length > 0) {
      setAnnexesUrl(urls);
      setFileName(listNamesFilesS3);
    } else {
      setAnnexesUrl([{ url: url, original: url }]);
      setFileName([principal ? principal.name : name]);
    }
  };
  useEffect(() => {
    downloadFileFromS3();
  }, []);
  const saveDocument = async (document, step) => {
    if (step.step.type === 'loadFilesStep') return;
    setLoadingSignatures(true);
    await GraphqlApi.updateDocument(documentItem).catch(console.error);
    setLoadingSignatures(false);
  };
  const calculateNumberOfPages = (page) => {
    const arrayOfPages = [];
    for (let i = 1; i <= page.length; i++) {
      arrayOfPages.push(i);
    }
    setNumberOfPages(arrayOfPages);
  };

  const calculatePositionToSave = (step) => {
    const element = document.getElementsByClassName('page');
    const numberPageSelected = step.pageNumber;
    const numberPageSelectedIndex = numberPageSelected - 1;
    const page = element[numberPageSelectedIndex];
    const pageWidth = page.clientWidth;
    const pageHeight = page.clientHeight;
    const x1 = step.position.x;
    const x2 = x1 + step.size.width;
    let heightPage = 0;
    [...new Array(numberPageSelectedIndex)].forEach((page, i) => {
      heightPage += element[i].clientHeight;
    });
    let y1 = step.position.y - heightPage;
    let y2 = y1 + step.size.height;

    const gap = numberPageSelectedIndex * pageBottomMargin;

    const position = {
      boundingRect: {
        height: pageHeight,
        width: pageWidth,
        x1: x1,
        x2: x2,
        y1: y1 - gap,
        y2: y2 - gap
      },
      pageNumber: numberPageSelected,
      rects: []
    };
    return position;
  };

  useMutationObserver(myRef, getPdfWithAndHeight);

  function getPdfWithAndHeight (mutations) {
    const pdfWithoutMargin = document.getElementsByClassName('removePageBorders');
    const page = document.getElementsByClassName('page');
    if (page.length !== numberOfPages.length) {
      calculateNumberOfPages(page);
    }
    const pdfHighlighter = document.getElementsByClassName('PdfHighlighter');
    if (pdfHighlighter.length) pdfHighlighter[0].style.overflow = 'hidden';
    if (pdfWithoutMargin.length && page.length) {
      setWidth(page[0].clientWidth);
      const left = (pdfWithoutMargin[0].clientWidth - page[0].clientWidth) / 2;
      setLeftMargin(left);
      setHeight(pdfWithoutMargin[0].clientHeight);
    }
  }

  const flowConstructor = (emails) => {
    const allEmailAreValid = !stepsSignatures[expanded].some(elm => !elm.isValidated);
    setNotValidatedEmails(!allEmailAreValid);
    const steps = stepsSignatures[expanded].map((step) => step.step);
    const formData = {
      steps
    };
    if (allEmailAreValid) {
      onSubmit(formData, emails);
    }
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const updateStepsProps = async ({ step: targetStep, data }) => {
    const { eventType } = data;
    if (eventType === 'onDrag') {
      setStepsSignatures(prevState => onDragStep({ prevState, targetStep, data }));
      setStepsCopyRender(stepsSignatures[expanded]);
      await saveDocument(documentItem, targetStep);
    } else if (eventType === 'onResize') {
      setStepsSignatures(prevState => onResizeStep({ prevState, targetStep, data }));
      setStepsCopyRender(stepsSignatures[expanded]);
      saveDocument(documentItem, targetStep);
    } else if (eventType === 'onDrop') {
      setStepsSignatures((prevState) => onDropStep({ prevState, targetStep }));
      setStepsCopyRender(stepsSignatures[expanded]);
      await saveDocument(documentItem, targetStep);
    } else if (eventType === 'onDelete') {
      if (targetStep.step.type === 'qrSignStep') return;
      setStepsSignatures((prevState) => onDeleteStep({ prevState, targetStep }));
      setStepsCopyRender(stepsSignatures[expanded]);
      await saveDocument(documentItem, targetStep);
    } else if (eventType === 'onChangeEmail') {
      setStepsSignatures((prevState) => onChangeEmail({ prevState, targetStep, data }));
      setStepsCopyRender(stepsSignatures[expanded]);
    } else if (eventType === 'onValidateEmail') {
      setStepsSignatures((prevState) => onValidateEmails({ prevState, targetStep, data }));
      setStepsCopyRender(stepsSignatures[expanded]);
    } else if (eventType === 'onPageChange') {
      setStepsSignatures((prevState) => onPageChange({ prevState, targetStep, data }));
      setStepsCopyRender(stepsSignatures[expanded]);
      await saveDocument(documentItem, targetStep);
    }
  };

  const onPageChange = ({ prevState, targetStep, data: { data: { pageNumber } } }) => {
    const stepsSignaturesExpanded = prevState[expanded];
    const newStepsSignatures = stepsSignaturesExpanded.map((step, index) => {
      if (step.signaturePositionId === targetStep.signaturePositionId) {
        const recalculatePageNumber = () => {
          const actualPageNumber = step.pageNumber;
          const newPageNumber = pageNumber;
          if (actualPageNumber < newPageNumber) {
            const difference = newPageNumber - actualPageNumber;
            return step.position.y + (difference * (pageHeight + pageBottomMargin));
          } else if (actualPageNumber > newPageNumber) {
            const difference = actualPageNumber - newPageNumber;
            return step.position.y - (difference * (pageHeight + pageBottomMargin));
          } else if (actualPageNumber === newPageNumber) {
            return step.position.y;
          }
        };
        const newStep = {
          ...step,
          pageNumber: pageNumber,
          position: {
            x: step.position.x,
            y: recalculatePageNumber() === 0 ? 1 : recalculatePageNumber()
          },
          positioned: true,
          step: {
            ...step.step
          }
        };
        return newStep;
      } else {
        return step;
      }
    });
    updateDocumentItem(newStepsSignatures, expanded);
    prevState[expanded] = newStepsSignatures;
    return prevState;
  };

  const onValidateEmails = ({ prevState, targetStep, data }) => {
    const regex = new RegExp('^(\\S+@\\S+\\.\\w+)(,\\s*\\S+@\\S+\\.\\w+)*$');

    const newStepsSignatures = prevState.map((arraySteps, index) => {
      const newArraySteps = arraySteps.map((step) => {
        if (step.signaturePositionId === targetStep.signaturePositionId && !step.step.automatic) {
          const newStep = {
            ...step,
            isValidated: regex.test(step.step.email)
          };
          return newStep;
        } else {
          return step;
        }
      }
      );
      return newArraySteps;
    });
    return newStepsSignatures;
  };

  const onChangeEmail = ({ prevState, targetStep, data }) => {
    const newStepsSignatures = prevState.map((arraySteps, index) => {
      const newArraySteps = arraySteps.map((step) => {
        if (step.signaturePositionId === targetStep.signaturePositionId) {
          const newStep = {
            ...step,
            step: {
              ...step.step,
              email: data.data.email
            }
          };
          return newStep;
        } else {
          return step;
        }
      }
      );
      return newArraySteps;
    });
    return newStepsSignatures;
  };
  const updateDocumentItem = (arraySteps, index) => {
    if (index === 0) {
      documentItem.principal.signaturesPositions = arraySteps.reduce((acc, step, i) => {
        if (step.step.type === 'qrSignStep') {
          return acc;
        }
        if (step.step.type === 'loadFilesStep') {
          return acc;
        }

        acc.push(calculatePositionToSave(step));
        return acc;
      }, []);
    } else {
      if (!documentItem.annexes[index - 1].skip) {
        documentItem.annexes[index - 1].signaturesPositions = arraySteps.reduce((acc, step, i) => {
          if (step.step.type === 'qrSignStep') {
            return acc;
          }
          if (step.step.type === 'loadFilesStep') {
            return acc;
          }

          acc.push(calculatePositionToSave(step));
          return acc;
        }, []);
      }
    }
  };

  const onDragStep = ({ prevState, targetStep, data }) => {
    const stepsSignaturesExpanded = prevState[expanded];
    const position = {
      x: data.data.x,
      y: data.data.y
    };
    let newStepsSignatures = stepsSignaturesExpanded.map((step, index) => {
      if (step.signaturePositionId === targetStep.signaturePositionId) {
        const newStep = {
          ...targetStep,
          position,
          positioned: true,
          pageNumber: Math.ceil(position.y / (pageHeight + pageBottomMargin)) === 0 ? 1 : Math.ceil(position.y / (pageHeight + pageBottomMargin))

        };
        return newStep;
      } else {
        return step;
      }
    });
    newStepsSignatures = calculateNotPositionedSteps(newStepsSignatures);
    updateDocumentItem(newStepsSignatures, expanded);
    prevState[expanded] = newStepsSignatures;
    return prevState;
  };

  const onResizeStep = ({ prevState, targetStep, data }) => {
    const size = {
      width: data.ref.clientWidth,
      height: data.ref.clientHeight
    };
    const stepsSignaturesExpanded = prevState[expanded];
    let newStepsSignatures = stepsSignaturesExpanded.map((signature, index) => {
      if (signature.signaturePositionId === targetStep.signaturePositionId) {
        const newStep = {
          ...targetStep,
          size,
          positioned: true
        };
        return newStep;
      } else {
        return signature;
      }
    });
    newStepsSignatures = calculateNotPositionedSteps(newStepsSignatures);
    updateDocumentItem(newStepsSignatures, expanded);
    prevState[expanded] = newStepsSignatures;
    return prevState;
  };
  const onDropStep = ({ prevState, targetStep: stepToDrop }) => {
    stepToDrop.pageNumber = Math.ceil(stepToDrop.position.y / (pageHeight + pageBottomMargin));
    const newStepsSignatures = prevState.map((arraySteps, index) => {
      if (index === expanded) {
        arraySteps.push({ ...stepToDrop, positioned: true });
      } else {
        arraySteps.push({ ...stepToDrop, positioned: false });
        arraySteps = calculateNotPositionedSteps(arraySteps);
      }
      updateDocumentItem(arraySteps, index);

      return arraySteps;
    });

    return newStepsSignatures;
  };
  const onDeleteStep = ({ prevState, targetStep: stepToDelete }) => {
    const { signaturePositionId: signaturePositionIdToDelete } = stepToDelete;
    const newStepsSignatures = prevState.map((arraySteps, index) => {
      const newArraySteps = arraySteps.filter(step => step.signaturePositionId !== signaturePositionIdToDelete);

      const rePositionatedSteps = calculateNotPositionedSteps(newArraySteps);

      updateDocumentItem(rePositionatedSteps, index);
      return rePositionatedSteps;
    });

    return newStepsSignatures;
  };

  const calculateNotPositionedSteps = (steps) => {
    let counter = 0;
    let actualSignaturesInRow = 0;
    const newArraySteps = steps.map((step) => {
      if (step.positioned) {
        return step;
      } else {
        const maxSignaturesPerRow = Math.trunc(width / 240);

        const row = Math.trunc(counter / maxSignaturesPerRow);

        if (actualSignaturesInRow === maxSignaturesPerRow) {
          actualSignaturesInRow = 0;
        }

        const position = {
          x: (actualSignaturesInRow * 220) + 20,
          y: (180 * row) + 20
        };
        const newStep = {
          ...step,
          position
        };
        counter++;
        actualSignaturesInRow++;

        return newStep;
      }
    });
    return newArraySteps;
  };
  useEffect(() => {
  }, [stepsCopyRender]);

  return (
        <>
          {
            <AlertDialog
              description={t('customFlow:errorEmail')}
              open={notValidatedEmails}
              setOpen={setNotValidatedEmails}
              customAccept={t('alertDialog:yes')}
              customCancel={t('alertDialog:no')}
            />}
          {finalEmailModal ? <FinalEmailModal flowConstructor={flowConstructor} finalEmailModal={finalEmailModal} setFinalEmailModal={setFinalEmailModal} /> : null}
          <Grid style={{ paddingTop: '30px' }} container spacing={3}>
            <Grid item xs={2}>
              <Sticky>
                {steps &&
                <VerticalLinearStepper updateStepsProps={updateStepsProps} steps={stepsSignatures[expanded] || stepsCopyRender} /> }
                <Grid container item justify='flex-start'>
                  <Button
                    size='medium'
                    color='primary'
                    onClick={() => setSelected(null)}
                    disabled={loading}
                    className={classes.marginRight}
                  >
                    {t('createFlowWithGrids:cancel')}
                  </Button>
                  <Button
                    color='primary'
                    variant='contained'
                    onClick={() => setFinalEmailModal(true)}
                    disabled={loading}
                  >
                    {t('createFlowWithGrids:create')}
                  </Button>
                </Grid>
              </Sticky>
            </Grid>
            <Grid style={{ position: 'relative', minHeight: height + 30 }} item xs={8}>
              <form ref={formRef} onSubmit={(e) => {
                e.preventDefault();
              }}>

                {annexesUrl.map((url, i) =>
                  <Accordion
                    expanded={expanded === i}
                    onChange={handleChange(i)}
                    key={i}
                    classes={{ root: classes.root, expanded: classes.expanded }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon className='document-expandDocument' />}
                      aria-controls='panel1a-content'
                      id='panel1a-header'
                      classes={{ content: classes.content }}
                    >
                      <Grid container style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}>
                        <Typography>{filesName[i]}</Typography>
                        {(!annexes[i - 1] || !annexes[i - 1].skip) ? null
                          : <Typography style={{
                            color: 'gray',
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                          }}>{t('customFlow:withoutSignature')}</Typography>
                        }
                      </Grid>

                    </AccordionSummary>
                    <AccordionDetails id='scroll'>
                      <div
                        className={classes.containerPdf}
                        style={{
                          height: height + paddingAccordion
                        }}
                      >
                        {expanded === i &&
                         <>
                           <div ref={myRef}>
                             { height && (!annexes[i - 1] || !annexes[i - 1].skip) &&
                             <>
                               {
                                 <DropContainer
                                   steps={steps}
                                   stepsSignatures={stepsSignatures[expanded] || []}
                                   width={width}
                                   height={height}
                                   setActiveStep={setActiveStep}
                                   leftMargin={leftMargin}
                                   activeStep={activeStep}
                                   updateStepsProps={updateStepsProps}
                                   isDragging={isDragging}
                                   setIsDragging={setIsDragging}
                                   setWriting={setWriting}
                                   numberOfPages={numberOfPages}
                                 /> }
                               </>
                             }
                             <PdfComponent url={url.url} customFlow type={type} item={input} input={url} />

                           </div>
                        </>
                        }
                      </div>
                    </AccordionDetails>
                  </Accordion>)}

              </form>
            </Grid>
            <Grid style={{
              height: window.visualViewport.height
            }} item xs={2}>
              <div style={{
                display: 'flex',
                flexDirection: 'column'
              }}>
                <Sticky>
                  <Grid style={{
                    filter: loadingSignatures ? 'blur(2px)' : null
                  }} item xs={12}>
                    { loadingSignatures && <CircularProgress style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',

                      zIndex: '1'

                    }} />}
                    <DropSignatures setIsDragging={setIsDragging} loadingSignatures={loadingSignatures} steps={steps} />
                  </Grid>
                </Sticky>
              </div>
            </Grid>
          </Grid>
        </>
  );
};
export default CustomFlow
;
